module.exports = __webpack_public_path__ + "static/img/loginUserBg.17debe45.png";